"use client";

import BreadcrumbCustom from "@/src/component/detail/breadcrumb";
import { DateTime } from "luxon";
import React, { useMemo, useState } from "react";
import "./style.scss";
import { Button, Col, Collapse, Row } from "antd";
import Image from "next/image";
import Link from "next/link";
import imageDaNang from "@/public/image/top-clinic-da-nang.webp";
import imageNgheAn from "@/public/image/top-clinic-nghe-an.webp";
import imageHaiPhong from "@/public/image/top-clinic-hai-phong.webp";
import imageBacNinh from "@/public/image/top-clinic-bac-ninh.webp";
import ImageHCM from "@/public/image/top-clinic-tp-hcm.webp";
import imageHN from "@/public/image/top-clinic-ha-noi.webp";
import nhakhoahub from "@/public/image/logo-nha-khoa-hub-cta.png";
import iconArrow from "@/public/icon/ChevronDownWhite.svg";
import useWindowSize from "@/src/hooks/useWindowSize";
import chevronDown from "@/public/icon/chevron-down.png";

const TopClinicClient = ({ questions }) => {
  const [expanded, setExpanded] = useState(false);
  const topClinicByProvince = [
    {
      image: imageHN,
      alt: "Top nha khoa uy tín tại Hà Nội",
      slug: "ha-noi",
    },
    {
      image: ImageHCM,
      alt: "Top nha khoa uy tín tại TP.Hồ Chí Minh",
      slug: "ho-chi-minh",
    },
    {
      image: imageBacNinh,
      alt: "Top nha khoa uy tín tại Bắc Ninh",
      slug: "bac-ninh",
    },
    {
      image: imageHaiPhong,
      alt: "Top nha khoa uy tín tại Hải Phòng",
      slug: "hai-phong",
    },
    {
      image: imageNgheAn,
      alt: "Top nha khoa uy tín tại Nghệ An",
      slug: "nghe-an",
    },
    {
      image: imageDaNang,
      alt: "Top nha khoa uy tín tại Đà Nẵng",
      slug: "da-nang",
    },
  ];

  const { width } = useWindowSize();
  const isMobile = useMemo(() => {
    return width < 768;
  }, [width]);

  const currentMonthYear = DateTime.now().toFormat("MM/yyyy");
  return (
    <div className="wp-location">
      <div className="wp-head">
        <BreadcrumbCustom
          items={[
            { label: "Trang Chủ", href: "/" },
            { label: "Phòng khám", href: "/phong-kham" },
          ]}
        />
        <h1>
          [{currentMonthYear}] Top nha khoa được đánh giá tốt trên toàn quốc
        </h1>
        <div className="description">
          <div className={`content ${expanded ? "hide-content" : ""}`}>
            <p>
              Tổng hợp các đơn vị nha khoa uy tín tại tất cả các tỉnh, thành
              trên cả nước, giúp người dùng dễ dàng tra cứu và lựa chọn phòng
              khám phù hợp với khu vực sinh sống.{" "}
            </p>
            <p>
              <strong>
                Tại sao nên đặt lịch hẹn với nha khoa miễn phí trên toàn quốc
                cùng Nhakhoahub?
              </strong>
            </p>
            <p>
              Trang tổng hợp này quy tụ hàng trăm phòng khám nha khoa được đánh
              giá cao về chất lượng dịch vụ, đội ngũ bác sĩ và trang thiết bị.
              Mỗi đơn vị được giới thiệu đều đã qua quá trình chọn lọc kỹ lưỡng,
              đảm bảo cung cấp thông tin trung thực, khách quan và hữu ích cho
              người đọc. Sự đa dạng trong lựa chọn cũng giúp người dùng dễ dàng
              so sánh và tìm ra nơi phù hợp nhất với nhu cầu cá nhân.
            </p>
            <p>
              Tất cả các phòng khám đã tích hợp sẵn tính năng đặt lịch khám trực
              tuyến ngay trên trang. Người dùng chủ động sắp xếp thời gian mà
              không cần gọi điện hay đến trực tiếp. Đây là điểm cộng lớn cho
              trải nghiệm, đặc biệt với những ai có lịch trình bận rộn hoặc muốn
              hạn chế thời gian chờ đợi.
            </p>
            <p>
              Việc tìm kiếm một phòng khám nha khoa phù hợp sẽ trở nên đơn giản
              hơn bao giờ hết nhờ hệ thống phân loại theo từng tỉnh thành. Người
              dùng chỉ cần chọn khu vực đang sinh sống hoặc nơi muốn thăm khám,
              từ đó nhanh chóng truy cập vào danh sách các đơn vị nha khoa uy
              tín tại địa phương đó. Điều này giúp tiết kiệm thời gian tra cứu,
              đồng thời hạn chế tối đa việc bỏ sót những lựa chọn chất lượng gần
              mình.
            </p>
            <p>
              <strong>Quy trình đặt lịch cụ thể như sau: </strong>
            </p>
            <p>
              <strong>Bước 1</strong>: Chọn trang “Tìm phòng khám”
            </p>
            <p>
              <strong>Bước 2</strong>: Chọn khu vực hoặc tên phòng khám mong
              muốn sử dụng dịch vụ
            </p>
            <p>
              <strong>Bước 3</strong>: Đọc kỹ thông tin về nha khoa trước khi
              đặt lịch
            </p>
            <p>
              <strong>Bước 4</strong>: Chọn “Đặt lịch giữ chỗ” hoặc “Nhận tư
              vấn” rồi điền đủ thông tin cần thiết để đặt lịch trực tiếp với nha
              khoa hoặc chờ tư vấn viên liên hệ để hỗ trợ.
            </p>
          </div>
          {isMobile && (
            <Button
              className="btn-loadmore"
              type="link"
              onClick={() => setExpanded((prev) => !prev)}
              icon={
                <Image
                  src={chevronDown}
                  width={13}
                  height={13}
                  style={{
                    transform: `rotate(${expanded ? -90 : 90}deg)`,
                    transition: "transform 0.3s ease",
                    display: "flex",
                  }}
                />
              }
              iconPosition="end"
            >
              {expanded ? "Thu gọn" : "Xem thêm"}
            </Button>
          )}
        </div>
      </div>
      <div className="wp-above">
        <div className="wp-content">
          <div className="wp-top-clinic">
            <Row gutter={isMobile ? [18, 20] : [40, 40]}>
              {topClinicByProvince?.map((item, index) => (
                <Col xs={12} sm={12} md={12} lg={8} xl={8} key={index}>
                  <Link href={`/phong-kham/${item.slug}`}>
                    <Image
                      src={item.image}
                      loading="lazy"
                      quality={100}
                      alt={item.alt}
                    />
                  </Link>
                </Col>
              ))}
            </Row>
          </div>
          <div className="wp-redirect-clinic">
            <div className="wp-content">
              <div className="wp-action">
                <Image
                  src={nhakhoahub}
                  width={310}
                  height={160}
                  alt="logo-nhakhoahub"
                  className="item"
                />
                <p className="item">
                  Tìm hiểu thêm thông tin chi tiết và đặt lịch với các nha khoa{" "}
                </p>
                <Link href="/tim-phong-kham">
                  <Button className="item" type="link">
                    TÌM NHA KHOA GẦN BẠN
                  </Button>
                </Link>
              </div>
            </div>
          </div>
          <div className="wp-clinic-nearby"></div>
          <div className="wp-faq">
            <h2>Câu hỏi thường gặp</h2>
            <Collapse
              accordion
              expandIconPosition="end"
              bordered={false}
              expandIcon={({ isActive }) => (
                <div
                  style={{
                    transform: `rotateX(${isActive ? 0 : 180}deg)`,
                  }}
                >
                  <Image
                    src={iconArrow}
                    width={25}
                    height={25}
                    className="collapse-expand-icon"
                    alt="icon"
                  />
                </div>
              )}
            >
              {questions?.map((item, index) => {
                const answer = "➤ " + item.answer.replace(/\n/g, "<br />");
                return (
                  <Collapse.Panel
                    header={
                      <>
                        <div className="wp-faq__index">{index + 1}</div>
                        <h3>{item.question}</h3>
                      </>
                    }
                    key={item.id}
                    style={{ border: "none" }}
                  >
                    <p dangerouslySetInnerHTML={{ __html: answer }} />
                  </Collapse.Panel>
                );
              })}
            </Collapse>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopClinicClient;
